import { Helmet } from "react-helmet-async"
import { useOutletContext } from "react-router"
import {
	TTouristProfile,
	TouristProfileDetails,
} from "../../../../TouristProfiles"

export default function TouristProfileDetailsPage() {
	const { touristProfile, revalidate } = useOutletContext<{
		touristProfile: TTouristProfile
		revalidate: () => void
	}>()
	return (
		<>
			<Helmet>
				<title>Tourist Profile Details</title>
			</Helmet>
			<TouristProfileDetails
				touristProfile={touristProfile}
				onChange={revalidate}
			/>
		</>
	)
}
